import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { SearchRounded } from '@mui/icons-material';

type ActionResponse = { id: string }[];

export type AndieGetAvailableDashboardsProps = ActionRenderAi<ActionResponse>;

const AndieGetAvailableDashboards = (props: AndieGetAvailableDashboardsProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-available-dashboards.title')}
            icon={<SearchRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-available-dashboards.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-available-dashboards.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetAvailableDashboards;
